// eslint-disable-next-line import-x/no-named-as-default
import DS from 'ember-data';
import { tracked } from '@glimmer/tracking';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class GuestIdentityVerificationConfigurationRepositoryService extends BaseRepositoryService<
  ModelRegistry['guest-identity-verification-configuration']
> {
  recordName = 'guest-identity-verification-configuration';
  implementMethods = ['findRecord', 'createRecord', 'unloadAll'];

  @tracked
  currentConfiguration!: ModelRegistry['guest-identity-verification-configuration'];

  public async getDefaultRecord(): Promise<
    DS.PromiseObject<ModelRegistry['guest-identity-verification-configuration']>
  > {
    let record;

    try {
      record = await this.findRecord('me');
    } catch {
      record = this.createRecord();
    }

    this.currentConfiguration = record;

    return record;
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/guest-identity-verification-configuration': GuestIdentityVerificationConfigurationRepositoryService;
  }
}
